module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Sửa phường xã",
      "breadcrumbs": [{
        title: 'Quản lý phường xã',
        route: {
          name: 'ward'
        }
      }]
    }
  }), _vm._v(" "), (_vm.localWard.id) ? _c('div', {
    staticClass: "padding-all"
  }, [_c('el-form', {
    ref: "createWardForm",
    attrs: {
      "model": _vm.localWard,
      "rules": _vm.rules,
      "label-width": "200px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmit()
      }
    }
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Chọn tỉnh thành",
      "prop": "city_id"
    }
  }, [_c('el-select', {
    staticClass: "width-100",
    attrs: {
      "filterable": "",
      "placeholder": "Chọn tỉnh thành"
    },
    on: {
      "change": _vm.getDistricts
    },
    model: {
      value: (_vm.localWard.city_id),
      callback: function($$v) {
        _vm.$set(_vm.localWard, "city_id", $$v)
      },
      expression: "localWard.city_id"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Chọn tỉnh thành",
      "value": 0
    }
  }), _vm._v(" "), _vm._l((_vm.cities), function(city) {
    return _c('el-option', {
      key: city.id,
      attrs: {
        "label": city.name,
        "value": city.id
      }
    })
  })], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Chọn quận huyện",
      "prop": "district_id"
    }
  }, [_c('el-select', {
    staticClass: "width-100",
    attrs: {
      "filterable": "",
      "placeholder": "Chọn quận huyện"
    },
    model: {
      value: (_vm.localWard.district_id),
      callback: function($$v) {
        _vm.$set(_vm.localWard, "district_id", $$v)
      },
      expression: "localWard.district_id"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Chọn quận huyện",
      "value": 0
    }
  }), _vm._v(" "), _vm._l((_vm.districts), function(district) {
    return _c('el-option', {
      key: district.id,
      attrs: {
        "label": district.name,
        "value": district.id
      }
    })
  })], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên"
    },
    model: {
      value: (_vm.localWard.name),
      callback: function($$v) {
        _vm.$set(_vm.localWard, "name", $$v)
      },
      expression: "localWard.name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, _vm._l((_vm.listCarriers), function(carrier, index) {
    return _c('el-col', {
      key: index,
      attrs: {
        "span": 8
      }
    }, [_c('el-form-item', {
      key: _vm.localWard[carrier.key],
      attrs: {
        "label": carrier.name
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": carrier.name
      },
      model: {
        value: (_vm.localWard[carrier.key]),
        callback: function($$v) {
          _vm.$set(_vm.localWard, carrier.key, $$v)
        },
        expression: "localWard[carrier.key]"
      }
    })], 1)], 1)
  }), 1), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Các loại tên",
      "prop": "map_name"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "allow-create": "",
      "default-first-option": "",
      "reserve-keyword": false,
      "placeholder": "Chọn các loại tên cho phường xã",
      "no-data-text": "Không có dữ liệu"
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.mapNames),
      callback: function($$v) {
        _vm.mapNames = $$v
      },
      expression: "mapNames"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_vm._v("Lưu")])])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-067764c7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ward/EditWard.vue
// module id = 690
// module chunks = 1